<ng-template  #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ (isCreate ? 'COMMON.ADD-CUS' : 'COMMON.EDIT-CUS') | translate}}</h4>
  </div>
  <div [formGroup]="buyerForm" #buyerFormDir="ngForm" (ngSubmit)="submit()" class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <label for="customer-name" class="required">{{'NORMAL.CUS-NAME' | translate}}</label>
        <input type="text"
            id="customer-name"
            class="form-control"
            formControlName="name">
        <ng-container *ngIf="name.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="branch-name" class="required">{{'TABLE.BRANCH-NAME' | translate}}</label>
        <div class="row justify-content-center align-items-center">
          <div class="col-md">
            <input type="text"
                id="branch-name"
                class="form-control"
                (keyup)="setHeadOfficeCheckbox($event)"
                formControlName="branchName">
          </div>
          <div class="col-md-auto">
            <p-checkbox class="dv-checkbox"
                binary="true"
                label="{{'DATA.HEAD-OFFICE'|translate}}"
                [(ngModel)]="isHeadOffice"
                [ngModelOptions]="{standalone: true}"
                (onChange)="setBuyerHeadOffice()">
            </p-checkbox>
          </div>
        </div>
        <ng-container *ngIf="branchName.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="branch-code" class="required">{{'TABLE.BRANCH-CODE' | translate}}</label>
        <input type="text"
            id="branch-code"
            class="form-control"
            maxlength="5"
            (keypress)="numberOnly($event)"
            formControlName="branchCode">
        <ng-container *ngIf="branchCode.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
        <ng-container *ngIf="branchCode.errors?.branchCodeInvalid && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.INVALID' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="address" class="required">{{'FILTER.ADDRESS' | translate}}</label>
        <input type="text"
            id="address"
            class="form-control"
            formControlName="address">
        <ng-container *ngIf="address.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="post-code"
            [ngClass]="{'required': country.value === 'TH'}">
          {{'DATA.DELIVERY-POSTALCODE' | translate}}
        </label>
        <input type="text"
            id="post-code"
            class="form-control"
            formControlName="postCode">
        <ng-container *ngIf="postCode.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
        <ng-container *ngIf="postCode.errors?.postalCodeInvalid && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.INVALID' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="country" class="required">{{'DATA.COUNTRY' | translate}}</label>
        <ng-select class="custom"
            [items]="countryList"
            labelForId="country"
            [bindLabel]="currentLang === 'en' ? 'country_name': 'country_name_th'"
            bindValue="country_code"
            placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
            [clearable]="false"
            formControlName="country"
            *ngIf="!refreshDropdown">
        </ng-select>
        <ng-container *ngIf="country.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="tax-id" class="required">{{'TABLE.TAX-ID' | translate}}</label>
        <input type="text"
            id="tax-id"
            class="form-control"
            formControlName="taxID">
        <ng-container *ngIf="taxID.errors?.required && buyerFormDir.submitted">
          <span class="text-danger">{{'ERROR.REQUIRED' | translate}}</span>
        </ng-container>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="email">{{'EMAIL-DASHBOARD.EMAIL' | translate}}</label>
        <input type="text"
            id="email"
            class="form-control"
            formControlName="email">
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col">
        <label for="cc-email">{{'EMAIL-DASHBOARD.CC-EMAIL' | translate}}</label>
        <input type="text"
            id="cc-email"
            class="form-control"
            formControlName="ccEmail">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row w-100percent no-gutters justify-content-between">
      <div class="col-auto">
        <button class="btn btn-dv btn-clean btn-wide" (click)="modal.close()">
          {{'COMMON.CANCEL'|translate}}
        </button>
      </div>
      <div class="col-auto">
        <button class="col-auto btn btn-dv btn-wide p-x-100crem" (click)="buyerFormDir.onSubmit()">
          {{'TEXT.SAVE'|translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.html